import { Link, useParams } from 'react-router-dom';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { useSEO } from '../../../hooks/useSEO';
import NotFound from '../../NotFound';
import { getBlogPost } from '../posts';

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = slug ? getBlogPost(slug) : undefined;

  useSEO({
    title: post?.title ?? 'ブログ',
    description: post?.description,
    keywords: '3Dプリンター,ブログ,フィラメント',
    canonicalPath: post ? `/blog/${post.slug}` : '/blog'
  });

  if (!post) {
    return <NotFound />;
  }

  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'ブログ', path: '/blog' },
    { label: post.title }
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-graphite mechanical-grid">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Breadcrumb items={breadcrumbItems} />

          <article className="static-card p-8 sm:p-12 mt-8 space-y-10">
            <header className="space-y-4">
              <div className="flex flex-wrap items-center gap-3">
                <span className="tech-label text-xs">{post.category}</span>
                <time dateTime={post.date} className="text-metal-light text-sm font-['Roboto_Mono']">
                  {post.date}
                </time>
              </div>
              <h1 className="text-3xl sm:text-4xl font-bold text-white font-['Exo'] leading-tight">
                {post.title}
              </h1>
              <div className="section-divider"></div>
            </header>
            {post.content}
          </article>

          <div className="mt-8 text-center">
            <Link
              to="/blog"
              className="inline-flex items-center space-x-2 text-accent hover:text-white transition-colors font-['Roboto_Mono']"
            >
              <i className="ri-arrow-left-line"></i>
              <span>ブログ一覧へ戻る</span>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPostPage;
